import { Grid, Typography } from "@material-ui/core"
import Box from "@material-ui/core/Box"
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import { Link, navigate } from "gatsby"
import React, { Fragment, useEffect, useState } from "react"
import {
  Layout,
  withRoot,
  Facebook,
  LogoCenter,
  RegisterBtn,
  Twitter,
  Loader,
} from "../components"
import { isLoggedIn } from "../utils/auth"
import {
  TextValidator,
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator"
import * as actionCreators from "../store/actions/userActions"
import { useDispatch, useSelector } from "react-redux"
import CheckboxValidator from "../components/Validations/CheckboxValidator"
import { userRolesList } from "../constants"
const styles = theme => ({
  section: {
    marginTop: theme.spacing(3),
  },
})

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#f5f5f6",
    },
  },

  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  display4: {
    fontSize: "2.5rem",
    fontWeight: 500,
  },
  display3: {
    fontWeight: "bold",
  },
  auth_form: {
    margin: "0 auto",
  },
  formGroup: {
    marginBottom: 0,
  },
  center: {
    display: "block",
    "& a": {
      display: "block",
    },
  },
  textField: {
    backgroundColor: "#ffffff",
    [`& fieldset`]: {
      borderRadius: 0,
    },
    "& .MuiOutlinedInput-root": {
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#27A6DE",
        },
      },
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#27A6DE",
          borderWidth: "1px",
        },
      },
    },
  },
}))

const SignUp = () => {
  const userRoles = userRolesList()
  const { isLoading, error, registrationStatus, message } = useSelector(
    state => ({
      isLoading: state.user.loading,
      error: state.user.error,
      registrationStatus: state.user.registrationStatus,
      message: state.user.message,
    })
  )

  const dispatch = useDispatch()

  const [formEl, setformEl] = useState({
    firstName: "",
    lastName: "",
    userEmail: "",
    userPassword: "",
    repeatPassword: "",
    privacyPolicy: false,
    userRole: "st",
  })

  useEffect(() => {
    // custom rule will have name 'isPasswordMatch'
    ValidatorForm.addValidationRule("isPasswordMatch", value => {
      if (value !== formEl.userPassword) {
        return false
      }
      return true
    })
  }, [formEl])

  useEffect(() => {
    ValidatorForm.addValidationRule("termRequired", value => value)
  }, [formEl])

  useEffect(() => {
    if (isLoggedIn()) {
      navigate("/user")
    }
  }, [])
  const classes = useStyles()

  const inputHandler = event => {
    const { name, value } = event.target
    setformEl({ ...formEl, [name]: value })
  }
  const checkboxHandler = event => {
    const { name, checked } = event.target
    setformEl({ ...formEl, [name]: checked })
  }
  const handleSubmit = event => {
    event.preventDefault()
    const userObj = {
      name: [{ value: formEl.userEmail }],
      mail: [{ value: formEl.userEmail }],
      pass: [{ value: formEl.userPassword }],
      first_name: [{ value: formEl.firstName }],
      last_name: [{ value: formEl.lastName }],
    }

    dispatch(actionCreators.userRegistration(userObj))
    // console.log(userObj)
    // if (registrationStatus) {
    //   setformEl({ ...formEl, [name]: value })
    // }
  }
  const [selectvalues, setSelectvalues] = useState({
    selectValue: "st",
  })
  const selectChange = name => event => {
    setSelectvalues({ ...selectvalues, [name]: event.target.value })
  }
  return (
    <Layout noHeader={true}>
      <Box component="section" className="hbku-pg-wrapper hbku-auth-wrapper">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box component="div" className="auth-form-wrap pt-70">
              <Box
                component="div"
                className="auth-form w-xl-35 w-lg-55 w-sm-75 w-100"
              >
                <LogoCenter />
                <ValidatorForm
                  onSubmit={event => {
                    handleSubmit(event)
                  }}
                  onError={errors => console.log(errors)}
                >
                  <Typography
                    className={classes.display4 + " " + "mb-10 text-center"}
                    component="h1"
                  >
                    Sign up in HBKU Website!
                  </Typography>
                  <Box component="div" className="formGroup">
                    <Grid item xs={12}>
                      <Loader isStart={isLoading} />
                      <h2>{error}</h2>
                      <h2>{message}</h2>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextValidator
                          id="firstName"
                          label="First Name"
                          name="firstName"
                          autoComplete="fname"
                          margin="dense"
                          variant="outlined"
                          className={classes.textField}
                          fullWidth
                          autoFocus
                          value={formEl.firstName}
                          onChange={inputHandler}
                          validators={["required"]}
                          errorMessages={[""]}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextValidator
                          id="lastName"
                          label="Last Name"
                          name="lastName"
                          autoComplete="lname"
                          margin="dense"
                          variant="outlined"
                          className={classes.textField}
                          fullWidth
                          value={formEl.lastName}
                          onChange={inputHandler}
                          validators={["required"]}
                          errorMessages={[""]}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box component="div" className="formGroup">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextValidator
                          id="userEmail"
                          label="Email Address"
                          type="email"
                          name="userEmail"
                          autoComplete="email"
                          margin="dense"
                          variant="outlined"
                          className={classes.textField}
                          fullWidth
                          value={formEl.userEmail}
                          onChange={inputHandler}
                          validators={["required", "isEmail"]}
                          errorMessages={["", "Email is not valid"]}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box component="div" className="formGroup">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextValidator
                          id="userPassword"
                          label="Password"
                          type="password"
                          name="userPassword"
                          autoComplete="password"
                          margin="dense"
                          variant="outlined"
                          className={classes.textField}
                          fullWidth
                          value={formEl.userPassword}
                          onChange={inputHandler}
                          validators={["required"]}
                          errorMessages={[""]}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box component="div" className="formGroup">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextValidator
                          id="repeatPassword"
                          label="Confirm Password"
                          type="password"
                          name="repeatPassword"
                          autoComplete="password"
                          margin="dense"
                          variant="outlined"
                          className={classes.textField}
                          fullWidth
                          value={formEl.repeatPassword}
                          onChange={inputHandler}
                          validators={["required", "isPasswordMatch"]}
                          errorMessages={["", "password mismatch"]}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box component="div" className="formGroup">
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextValidator
                          id="userRole"
                          name="userRole"
                          label="Select Category"
                          select
                          fullWidth
                          variant="outlined"
                          className={classes.textField}
                          margin="dense"
                          value={formEl.userRole}
                          onChange={inputHandler}
                          SelectProps={{
                            native: true,
                          }}
                          validators={["required"]}
                          errorMessages={[""]}
                          value={selectvalues.selectValue}
                          onChange={selectChange("selectValue")}
                        >
                          {userRoles.map(option => (
                            <option value={option.value} key={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </TextValidator>
                      </Grid>
                    </Grid>
                  </Box>
                  <FormControlLabel
                    className="font-14"
                    control={
                      <CheckboxValidator
                        name="privacyPolicy"
                        checked={formEl.privacyPolicy}
                        value={formEl.privacyPolicy}
                        color="primary"
                        onChange={checkboxHandler}
                        validators={["termRequired"]}
                      />
                    }
                    label={
                      <Fragment>
                        <Box component="span">
                          I have read and agree to the{" "}
                        </Box>
                        <Link to={"/"}>term and conditions</Link>
                      </Fragment>
                    }
                  />
                  <RegisterBtn />
                  <Box component="div" className="option-sep">
                    {" "}
                    OR
                  </Box>
                  {/* <Grid container spacing={3} className="mb-20">
                    <Grid item xs={12} sm={6}>
                      {<Facebook />}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {<Twitter />}
                    </Grid>
                  </Grid> */}
                  <Typography component="div" align="center">
                    Already have an account?
                    <Link to="/login"> {"Sign In"} </Link>
                  </Typography>
                </ValidatorForm>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  )
}
export default withRoot(withStyles(styles)(SignUp))
